import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { httpReauest } from "../../utils/httpRequest";
import Loading from "../../components/common/Loading";
import { CDN_BASE_URL } from "../../config";
import CommentFormMobileBlog from "../../components/common/mobile/CommentFormMobileBlog";
import CommentsBlog from "../../components/common/mobile/CommentsBlog";
import RelatedProductsMobile from "../../components/common/mobile/RelatedProductsMobile";
import { Helmet } from "react-helmet";
import BlogsRelatedMobile from "../../components/common/mobile/BlogsRelatedMobile";
import RequestTalkModal from "../../components/common/mobile/RequestTalkModal";
import { DealerDataContext } from "../../context/DealerDataContext";

const BlogsDetailMobilePage = () => {
  const [selected, setselected] = useState("مقاله");
  const [show, setShow] = useState();

  const { name } = useParams();

  const { dealerData } = useContext(DealerDataContext);
  const [data, setData] = useState();
  const [loading, setloading] = useState();
  const [blogs, setBlogs] = useState();

  useEffect(() => {
    getData();
  }, [name]);

  async function getData() {
    setloading(true);
    await httpReauest("GET", "/blog/" + name, {}, {}).then(({ data }) => {
      setData(data?.data);
    });
    await httpReauest("GET", "/blog?limit=16", {}, {}).then(({ data }) => {
      setBlogs(data?.data);
    });
    setloading(false);
  }

  if (loading) {
    return (
      <div className="flex justify-center">
        <Loading />
      </div>
    );
  }
  return (
    <div>
      {show && <RequestTalkModal setShow={setShow} />}
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"1924 - " + data?.name}</title>
        <meta name="description" content={data?.meta_desc} />
        <meta name="keywords" content={data?.meta_keywords} />
        <meta name="og:description" content={data?.meta_desc} />
        <meta name="og:title" content={data?.name} />
        <meta name="author" content={data?.author} />
      </Helmet>{" "}
      <Link to={"/blogs"} className="flex gap-2 items-center text-[14px]">
        <img src="/Arrow - Left 2.png" alt="" className="w-[24px]" />
        بازگشت به اخبار و دانستنی ها
      </Link>
      <img
        src={CDN_BASE_URL + data?.cover}
        className="w-full rounded-[8px] my-4"
        alt=""
      />
      <h1 className="text-center title-mobile">{data?.name}</h1>
      <p className="desc">{data?.desc}</p>
      <div className="py-3">
        <Link
          to={`tel:${dealerData?.phone}`}
          className="btn-brand-mobile  w-full block text-center my-2"
        >
          {dealerData?.phone}
        </Link>
        <button
          onClick={() => setShow(true)}
          className="border-brand-2 p-3 w-full block text-center mt-3"
        >
          درخواست مشاوره تلفنی
        </button>
      </div>
      <div className="w-full flex gap-3 py-3 overflow-x-scroll border-b border-dashed border-[#8E9192] text-[14px]">
        <span
          onClick={() =>
            "مقاله" === selected ? setselected("") : setselected("مقاله")
          }
          className={`${
            selected === "مقاله" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"مقاله"}
        </span>
        <span
          onClick={() =>
            "نظرات" === selected ? setselected("") : setselected("نظرات")
          }
          className={`${
            selected === "نظرات" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"نظرات"}
        </span>
        <span
          onClick={() =>
            "محصولات مرتبط" === selected
              ? setselected("")
              : setselected("محصولات مرتبط")
          }
          className={`${
            selected === "محصولات مرتبط" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"محصولات مرتبط"}
        </span>
        <span
          onClick={() =>
            "مقالات مرتبط" === selected
              ? setselected("")
              : setselected("مقالات مرتبط")
          }
          className={`${
            selected === "مقالات مرتبط" ? "bg-black text-white" : ""
          } border-brand-2 px-3 py-2 whitespace-nowrap font-bold`}
        >
          {"مقالات مرتبط"}
        </span>
      </div>
      <div className="py-3">
        {selected == "مقاله" ? (
          <div
            className="desc_details overflow-x-scroll"
            dangerouslySetInnerHTML={{ __html: data?.content }}
          />
        ) : selected == "نظرات" ? (
          <>
            <CommentFormMobileBlog blog={data?._id} />
            <CommentsBlog blog={data?._id} />
          </>
        ) : selected == "محصولات مرتبط" ? (
          <>
            <RelatedProductsMobile related={data?.related} />
          </>
        ) : (
          <div className="grid grid-cols-6 grid-rows-subgrid py-2 gap-1">
            <BlogsRelatedMobile related={data?.related} />
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogsDetailMobilePage;
